import { InvoicePaymentMethod } from 'api';

export const filterAndMapEnabledPaymentMethods = (options: InvoicePaymentMethod[]) => {
  return options.filter((option) => option.enabled).map(({ type }) => type);
};
